import { materialPhysical } from "./mesh-factory/material-factory";

export const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

const DEFAULT_VISIBLE = false;
const DEFAULT_HELPER_VISIBLE = false;

// AXES HELPER
export const AXES_HELPER_SIZE_DEFAULT = 2;

// GEOMETRY
export const BOX_SIZE = 0.75;
export const BOX_POSITION_X_DEFAULT = 0;
export const BOX_POSITION_Y_DEFAULT = 0;
export const BOX_POSITION_Z_DEFAULT = 0;

export const SPHERE_RADIUS = 0.5;
export const SPHERE_POSITION_X_DEFAULT = -1.5;
export const SPHERE_POSITION_Y_DEFAULT = 0;
export const SPHERE_POSITION_Z_DEFAULT = 0;

export const TORUS_RADIUS = 0.3;
export const TORUS_POSITION_X_DEFAULT = 1.5;
export const TORUS_POSITION_Y_DEFAULT = 0;
export const TORUS_POSITION_Z_DEFAULT = 0;

export const FLOOR_WIDTH = 5;
export const FLOOR_HEIGHT = 5;
export const FLOOR_POSITION_X_DEFAULT = 0;
export const FLOOR_POSITION_Y_DEFAULT = -0.65;
export const FLOOR_POSITION_Z_DEFAULT = 0;

export const BOX_FAR_SIZE = 1;
export const BOX_FAR_POSITION_X_DEFAULT = 5;
export const BOX_FAR_POSITION_Y_DEFAULT = -5;
export const BOX_FAR_POSITION_Z_DEFAULT = 0;

// MATERIAL
export const defaultMaterial = materialPhysical;

// AMBIENT LIGHT
export const AMBIENT_LIGHT_COLOR_DEFAULT = 0xffffff;
export const AMBIENT_LIGHT_INTENSITY_DEFAULT = 0.5;
export const AMBIENT_LIGHT_POSITION_X_DEFAULT = 0;
export const AMBIENT_LIGHT_POSITION_Y_DEFAULT = 0;
export const AMBIENT_LIGHT_POSITION_Z_DEFAULT = 0;
export const AMBIENT_LIGHT_IS_VISIBLE_DEFAULT = DEFAULT_VISIBLE;

// DIRECTIONNAL LIGHT
export const DIRECTIONNAL_LIGHT_COLOR_DEFAULT = 0xff0000;
export const DIRECTIONNAL_LIGHT_INTENSITY_DEFAULT = 0.3;
export const DIRECTIONNAL_LIGHT_POSITION_X_DEFAULT = 1;
export const DIRECTIONNAL_LIGHT_POSITION_Y_DEFAULT = 0.25;
export const DIRECTIONNAL_LIGHT_POSITION_Z_DEFAULT = 0;
export const DIRECTIONNAL_LIGHT_IS_VISIBLE_DEFAULT = DEFAULT_VISIBLE;

// DIRECTIONNAL LIGHT HELPER
export const DIRECTIONNAL_LIGHT_HELPER_IS_VISIBLE_DEFAULT =
  DEFAULT_HELPER_VISIBLE;
export const DIRECTIONNAL_LIGHT_HELPER_SIZE_DEFAULT = 1;

// HEMISPHERE LIGHT
export const HEMISPHERE_LIGHT_SKY_COLOR_DEFAULT = 0xff0000;
export const HEMISPHERE_LIGHT_GROUND_DEFAULT = 0xffffff;
export const HEMISPHERE_LIGHT_INTENSITY_DEFAULT = 0.3;
export const HEMISPHERE_LIGHT_POSITION_X_DEFAULT = 0;
export const HEMISPHERE_LIGHT_POSITION_Y_DEFAULT = 1;
export const HEMISPHERE_LIGHT_POSITION_Z_DEFAULT = 0;
export const HEMISPHERE_LIGHT_IS_VISIBLE_DEFAULT = DEFAULT_VISIBLE;

// HEMISPHERE LIGHT HELPER
export const HEMISPHERE_LIGHT_HELPER_IS_VISIBLE_DEFAULT =
  DEFAULT_HELPER_VISIBLE;
export const HEMISPHERE_LIGHT_HELPER_SIZE_DEFAULT = 0.2;

// POINT LIGHT
export const POINT_LIGHT_COLOR_DEFAULT = 0xff9000;
export const POINT_LIGHT_INTENSITY_DEFAULT = 0.5;
export const POINT_LIGHT_DISTANCE_DEFAULT = 10;
export const POINT_LIGHT_DECAY_DEFAULT = 2;
export const POINT_LIGHT_POSITION_X_DEFAULT = 1;
export const POINT_LIGHT_POSITION_Y_DEFAULT = 0.5;
export const POINT_LIGHT_POSITION_Z_DEFAULT = 1;
export const POINT_LIGHT_IS_VISIBLE_DEFAULT = DEFAULT_VISIBLE;

// POINT LIGHT HELPER
export const POINT_LIGHT_HELPER_IS_VISIBLE_DEFAULT = DEFAULT_HELPER_VISIBLE;
export const POINT_LIGHT_HELPER_SIZE_DEFAULT = 0.2;

// RECTAREA LIGHT
export const RECTAREA_COLOR_DEFAULT = 0x4e00ff;
export const RECTAREA_INTENSITY_DEFAULT = 2;
export const RECTAREA_WIDTH_DEFAULT = 4;
export const RECTAREA_HEIGHT_DEFAULT = 2;
export const RECTAREA_POSITION_X_DEFAULT = -1.5;
export const RECTAREA_POSITION_Y_DEFAULT = 0;
export const RECTAREA_POSITION_Z_DEFAULT = 1.5;
export const RECTAREA_IS_VISIBLE_DEFAULT = DEFAULT_VISIBLE;

// RECTAREA LIGHT HELPER
export const RECTAREA_HELPER_IS_VISIBLE_DEFAULT = DEFAULT_HELPER_VISIBLE;

// SPOT LIGHT
export const SPOT_COLOR_DEFAULT = 0x78ff00;
export const SPOT_INTENSITY_DEFAULT = 0.5;
export const SPOT_DISTANCE_DEFAULT = 10;
export const SPOT_ANGLE_DEFAULT = Math.PI * 0.1;
export const SPOT_PENUMBRA_DEFAULT = 0.25;
export const SPOT_DECAY_DEFAULT = 1;
export const SPOT_POSITION_X_DEFAULT = 1;
export const SPOT_POSITION_Y_DEFAULT = 2;
export const SPOT_POSITION_Z_DEFAULT = 3;
export const SPOT_IS_VISIBLE_DEFAULT = true;

// SPOT LIGHT HELPER
export const SPOT_HELPER_IS_VISIBLE_DEFAULT = DEFAULT_HELPER_VISIBLE;
